"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateEnquiryStatusBodyDtoStatusEnum = void 0;
exports.instanceOfUpdateEnquiryStatusBodyDto = instanceOfUpdateEnquiryStatusBodyDto;
exports.UpdateEnquiryStatusBodyDtoFromJSON = UpdateEnquiryStatusBodyDtoFromJSON;
exports.UpdateEnquiryStatusBodyDtoFromJSONTyped = UpdateEnquiryStatusBodyDtoFromJSONTyped;
exports.UpdateEnquiryStatusBodyDtoToJSON = UpdateEnquiryStatusBodyDtoToJSON;
exports.UpdateEnquiryStatusBodyDtoToJSONTyped = UpdateEnquiryStatusBodyDtoToJSONTyped;
/**
 * @export
 */
exports.UpdateEnquiryStatusBodyDtoStatusEnum = {
    InProgress: 'in_progress',
    Open: 'open',
    Resolved: 'resolved'
};
/**
 * Check if a given object implements the UpdateEnquiryStatusBodyDto interface.
 */
function instanceOfUpdateEnquiryStatusBodyDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
function UpdateEnquiryStatusBodyDtoFromJSON(json) {
    return UpdateEnquiryStatusBodyDtoFromJSONTyped(json, false);
}
function UpdateEnquiryStatusBodyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'],
    };
}
function UpdateEnquiryStatusBodyDtoToJSON(json) {
    return UpdateEnquiryStatusBodyDtoToJSONTyped(json, false);
}
function UpdateEnquiryStatusBodyDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
    };
}
